import React, { useEffect, Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import { useAuthStore } from './store/authStore';

// Lazy load components
const LandingPage = React.lazy(() => import('./pages/LandingPage'));
const CheffiyPage = React.lazy(() => import('./pages/CheffiyPage'));
const SettingsPage = React.lazy(() => import('./pages/SettingsPage'));

// Loading component
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FF6F61]"></div>
  </div>
);

function App() {
  const { user, loading, checkAuth } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route 
            path="/" 
            element={user ? <Navigate to="/dashboard" /> : <LandingPage />} 
          />
          <Route 
            path="/dashboard" 
            element={user ? <CheffiyPage /> : <Navigate to="/" />} 
          />
          <Route 
            path="/kitchen" 
            element={user ? <CheffiyPage /> : <Navigate to="/" />} 
          />
          <Route 
            path="/search" 
            element={user ? <CheffiyPage /> : <Navigate to="/" />} 
          />
          <Route 
            path="/saved" 
            element={user ? <CheffiyPage /> : <Navigate to="/" />} 
          />
          <Route 
            path="/planner" 
            element={user ? <CheffiyPage /> : <Navigate to="/" />} 
          />
          <Route 
            path="/grocery" 
            element={user ? <CheffiyPage /> : <Navigate to="/" />} 
          />
          <Route 
            path="/pantry" 
            element={user ? <CheffiyPage /> : <Navigate to="/" />} 
          />
          <Route 
            path="/community" 
            element={user ? <CheffiyPage /> : <Navigate to="/" />} 
          />
          <Route 
            path="/community/recipe/:id" 
            element={user ? <CheffiyPage /> : <Navigate to="/" />} 
          />
          <Route 
            path="/settings" 
            element={user ? <SettingsPage /> : <Navigate to="/" />} 
          />
          <Route 
            path="*" 
            element={<Navigate to="/" />} 
          />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;